var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-component"},[_c('div',{staticClass:"d-flex justify-center mx-auto px-5 py-5"},[_c('v-progress-circular',{attrs:{"width":3,"color":"primary","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }